module.exports = __webpack_public_path__ + "img/standard_2.1234d6e8.png";